import React, { useMemo, useState } from 'react'
import { ConfirmationDialog } from 'uiComponents/popups/confirmationDialog'
import { useResendEmailMutation } from 'orders/reduxQueries'
import { getListOrderData, getSelectedOrdersList } from 'orders/orders/redux'
import { useAppSelector } from 'store/hooks'
import { Button } from '@mui/material'
import { MailSolid } from '@convious/icons'
import { showErrorMessage, showSuccessMessage } from 'uiComponents/message'

const Email = () => {
    const selectedOrderRowsIds = useAppSelector(getSelectedOrdersList)
    const currentData = useAppSelector(getListOrderData)?.data
    const selectedOrder = useAppSelector((state) => state.orderTable.selectedOrder)
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)
    const [resendEmail, { isLoading }] = useResendEmailMutation()
    const selectedRows = useMemo(() => {
        const ordersData = [...(currentData?.results ?? [])]
        if (selectedOrder && ordersData.length === 0) {
            ordersData.push(selectedOrder)
        }

        return ordersData.filter((order) => selectedOrderRowsIds.includes(order.id))
    }, [currentData, selectedOrderRowsIds, selectedOrder])

    if (selectedRows.length !== 1) {
        return null
    }

    const canGetTickets = !['cancelled', 'open'].includes(selectedRows[0].status)
    if (!canGetTickets || !selectedRows[0].customer?.email) {
        return null
    }

    const onResendEmail = async () => {
        const response = await resendEmail({ orderNumber: selectedRows[0].number })
        setShowConfirmationDialog(false)

        if ('data' in response) {
            showSuccessMessage(`Email to ${selectedRows[0].customer.email} sent successfully`, 'resent_successfully')
        } else {
            showErrorMessage('Oops! We could not send the email. Please try again.', 'unknown_error')
        }
    }

    return (
        <>
            {showConfirmationDialog && (
                <ConfirmationDialog
                    title="Resend order confirmation?"
                    text={`To: ${selectedRows[0].customer.email}`}
                    buttonText="Resend"
                    onCancel={() => setShowConfirmationDialog(false)}
                    onConfirm={onResendEmail}
                    loading={isLoading}
                />
            )}
            <Button
                size="medium"
                variant="outlined"
                color="primary"
                onClick={() => setShowConfirmationDialog(true)}
                id="resend-email-button"
                data-testid="orders-resend-email-button"
                startIcon={<MailSolid />}
                className="action-button"
            >
                Resend email
            </Button>
        </>
    )
}

export default Email
